import clsx from 'clsx';
import { Fragment } from 'react';
import Icon from '../Icon/Icon';
import styles from './StageBoxSegmentedControl.module.scss';
import type { StageBoxSegmentedControlProps } from './types';

const StageBoxSegmentedControl = <Value extends string>({
  selected,
  onChange,
  className,
  config,
  color = 'white',
}: StageBoxSegmentedControlProps<Value>) => {
  return (
    <div className={clsx(styles.base, className, styles[color])}>
      {config.map(({ icon, label, value }) => (
        <Fragment key={value}>
          <input
            type="radio"
            name="productOption"
            id={value}
            value={value}
            checked={selected === value}
            onChange={() => onChange(value)}
            className={styles.input}
          />
          <label htmlFor={value} className={styles.button}>
            <Icon variant={icon} size="iconSize24" className={styles.icon} />
            <span>{label}</span>
          </label>
        </Fragment>
      ))}
    </div>
  );
};

export default StageBoxSegmentedControl;
